<style>
.v-pagination .v-btn:hover > .v-btn__overlay {
  

  opacity: .15;
}
.v-table > .v-table__wrapper > table > tbody > tr > th, .v-table > .v-table__wrapper > table > thead > tr > th, .v-table > .v-table__wrapper > table > tfoot > tr > th {
  font-weight: bold;
}
</style>
<template>
  <v-app >
    <v-layout>
  <AppBar back="/" :title="'Mission histories'"></AppBar>
  <!-- {{ items }} -->
  <!-- <v-dialog height="70%" v-model="showReview"> -->
  <v-main overlay-opacity="0.15">
    <v-card >
    <v-tabs v-model="tab" color="primary" v-on:update:model-value="reloadTab($event)">
      <v-tab value="0">My missions</v-tab>
      <v-tab value="1">Shared missions</v-tab>
     
    </v-tabs>
    <v-table>
      <thead>
        <tr>
          <th class="text-center ms-date">
            <v-text-field 
              label="Date"
               :readonly="true"
               disabled="true"
            ></v-text-field>
           
            <!-- Date  -->
          </th>
          <!-- <th class="text-bold text-center">
            Mission code 
          </th> -->
          <th class="text-center ms-mission">
            <v-autocomplete
              ref="cacheMissions"
              label="Mission"
              auto-select-first
              v-model:search="searchMission"
              :custom-filter="missionValueFilter"
              :items="missionNames"
              v-model="missionNameModel"
              clearable="true"
              v-on:update:modelValue="()=>reloadTab(0,missionNameModel)"
            ></v-autocomplete>
          </th>
          <th class="text-center ms-user" v-if="tab==1">
            <v-autocomplete 
              label="User"
              :items="usernameList"
              auto-select-first
              v-model="usernameModel"
               clearable="true"
              v-on:update:modelValue="()=>reloadTab(1,missionNameModel,usernameModel)"
            ></v-autocomplete>
          </th>

          <th class="text-center ms-duration">
            <v-text-field 
              label="Duration"
               :readonly="true"
               disabled="true"
            ></v-text-field>
            
          </th>
          
          <th class="text-center ms-public" v-if="tab==0">
            <!-- {{tab==1?"Username":""}} -->
           
         
            <v-select 
              label="Is public"
              :items="[{title:'Eighther',value:-1},{title:'True',value:1}, {title:'False',value:0}]"
              
              v-model="isPublicQuery"
              v-on:update:modelValue="()=>reloadTab(0,missionNameModel)"
            ></v-select>
          </th>
          
         
          
        </tr>
       
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>
        <tr v-if="!loading" v-for="item in listMissionsData.data" :key="item.mission_run_id">
          <td>{{ item.start_date }}</td>
          <!-- <td>{{ item.mission_run_id }}</td> -->
          <td>
            <div class="btn-group">


              <a target="blank" class="btn btn-primary w100" :href="getReplayLink(item)"> {{ item.mission_name }}

                <v-tooltip activator="parent" location="top">Click to replay mission {{ item.mission_run_id }}</v-tooltip>

              </a>
              <a class="btn btn-secondary" v-on:click="copyToClipboard(item)">
                <i class="fa fa-copy"></i>
                <v-tooltip activator="parent" location="top">{{ item.hover }}</v-tooltip>
              </a>
            </div>
          </td>
          <td v-if="tab==1"> 
           
              <div>{{item.username}}</div>
          </td>

          <td>{{ item.duration }}</td>
          <td v-if="tab==0" >  
            <v-switch :model-value="`${item.is_public}`" color="success"
              v-on:update:model-value="updatePublish(item)($event)" true-value="1" false-value="0"></v-switch>
              <div v-if="tab==1">{{item.username}}</div>
          </td>
          
         
         
        </tr>
        <tr v-if="!loading && listMissionsData.data.length">
          <td colspan="4">
            <v-pagination
            v-model="page"
            v-on:update:model-value="reloadPage($event)"
            class=""
            :length="pageCount"
          ></v-pagination>
          </td>
        </tr>
      </tbody>
    </v-table>

  </v-card>
</v-main>
</v-layout>
  <!-- </v-dialog> -->
</v-app>
</template>

<script src="./histories"></script>
